module.exports = __webpack_public_path__ + "assets/fa-music.svg";